import React from 'react';
import { Building2, DollarSign, AlertTriangle, Users } from 'lucide-react';
import { formatarMoeda } from '../../utils/formatadores';

const CardsResumo = ({ dadosContaBancaria }) => {
    return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      <div className="bg-[color:var(--surface)] border border-[color:var(--border)] rounded-lg p-3">
        <div className="flex items-center gap-3">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-500/15 text-blue-500">
            <Building2 className="h-4 w-4" />
          </span>
          <div>
            <p className="text-xs text-[color:var(--text-muted)] font-medium">Contas Bancárias</p>
            <p className="text-[13px] sm:text-[14px] font-bold text-[color:var(--text-primary)] tracking-tight truncate">{dadosContaBancaria.length}</p>
          </div>
        </div>
      </div>
      
      <div className="bg-[color:var(--surface)] border border-[color:var(--border)] rounded-lg p-3">
        <div className="flex items-center gap-3">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-emerald-500/15 text-emerald-500">
            <DollarSign className="h-4 w-4" />
          </span>
          <div>
            <p className="text-xs text-[color:var(--text-muted)] font-medium">Valor Total</p>
            <p className="text-[13px] sm:text-[14px] font-bold text-[color:var(--text-primary)] tracking-tight truncate">
              {formatarMoeda(dadosContaBancaria.reduce((sum, conta) => sum + conta.valorTotal, 0))}
            </p>
          </div>
        </div>
      </div>
      
      <div className="bg-[color:var(--surface)] border border-[color:var(--border)] rounded-lg p-3">
        <div className="flex items-center gap-3">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-orange-500/15 text-orange-500">
            <AlertTriangle className="h-4 w-4" />
          </span>
          <div>
            <p className="text-xs text-[color:var(--text-muted)] font-medium">Contas Vencidas</p>
            <p className="text-[13px] sm:text-[14px] font-bold text-[color:var(--text-primary)] tracking-tight truncate">
              {dadosContaBancaria.reduce((sum, conta) => sum + conta.contasVencidas, 0)}
            </p>
          </div>
        </div>
      </div>
      
      <div className="bg-[color:var(--surface)] border border-[color:var(--border)] rounded-lg p-3">
        <div className="flex items-center gap-3">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-purple-500/15 text-purple-500">
            <Users className="h-4 w-4" />
          </span>
          <div>
            <p className="text-xs text-[color:var(--text-muted)] font-medium">Fornecedores Únicos</p>
            <p className="text-[13px] sm:text-[14px] font-bold text-[color:var(--text-primary)] tracking-tight truncate">
              {dadosContaBancaria.reduce((sum, conta) => sum + conta.fornecedoresUnicos, 0)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardsResumo;






